declare namespace $ {

	type $shm_ba_post_card__table_shm_ba_agent_message_posts_1 = $mol_type_enforce<
		ReturnType< $shm_ba_agent_message_posts['table'] >
		,
		ReturnType< $shm_ba_post_card['table'] >
	>
	type $shm_ba_post_card__post_row_shm_ba_agent_message_posts_2 = $mol_type_enforce<
		ReturnType< $shm_ba_agent_message_posts['post_row'] >
		,
		ReturnType< $shm_ba_post_card['post_row'] >
	>
	type $mol_paragraph__title_shm_ba_agent_message_posts_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	export class $shm_ba_agent_message_posts extends $mol_view {
		rows( ): readonly(any)[]
		table( ): any
		post_row( id: any): any
		sub( ): ReturnType< $shm_ba_agent_message_posts['rows'] >
		Post( id: any): $shm_ba_post_card
		Empty( ): $mol_paragraph
	}
	
}

//# sourceMappingURL=posts.view.tree.d.ts.map